import { Button, Grid } from '@mui/material'
import { ProceedPaymentButton } from 'components/Sell/payment/PaymentDetailUI'
import { useTranslation } from 'react-i18next'
import styles from 'components/Sell/payment/paymentDialog.style'

interface IFinishPaymentButton {
    onConfirm: () => void
    onCancel: () => void
    isReadyToProceedPayment: boolean
    isMoneyCollect: boolean
    confirmText?: string
}

function FinishPaymentButton({
    onConfirm,
    onCancel,
    isReadyToProceedPayment,
    isMoneyCollect,
    confirmText,
}: IFinishPaymentButton) {
    const { t } = useTranslation()
    return (
        <Grid item container spacing={1} alignItems="center">
            <Grid item xs>
                <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    size="large"
                    sx={styles.confirmButton}
                    onClick={onCancel}
                >
                    Cancel
                </Button>
            </Grid>
            <Grid item xs>
                <ProceedPaymentButton
                    onClick={onConfirm}
                    isReadyToProceedPayment={isReadyToProceedPayment}
                    isMoneyCollect={isMoneyCollect}
                    caption={confirmText ?? t('button.confirm')}
                />
            </Grid>
        </Grid>
    )
}
export default FinishPaymentButton
